import React, { useState, useEffect } from 'react'
import axios from 'axios';
import StepProgressBar from '../common/stepBar';
import BackButton from '../common/backButton';
import InfoModal from '../common/InfoModal';
import { BiInfoCircle, BiLogoApple } from 'react-icons/bi';
import { BMICALCULATOR, BUDDYGAMEBYID, BUDDYGAMEUPDATE, HOME, LOGINWITHSOCIAL, BUDDYTOURNAMENTJOIN, BUDDYGAMEJOIN, ONBOARDING, LOGINUSER, VERIFYOTP, FORGOTPASSWORD, REGISTER } from '../helpers/Constant';
import { getDataWithToken, postData, postDataWithToken } from '../api/api';
import { getUserInfo, getUserType, setSession, setUserType } from '../utils/common';
import { useNavigate } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import { BiLogoFacebook, BiRightArrowAlt } from 'react-icons/bi';
import { Oval } from 'react-loader-spinner';
import { FaCrown } from 'react-icons/fa';
import { FaCheck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function Login() {
  const navigate = useNavigate();
  const pendingStep = 1;
  const { t } = useTranslation();
  const [buddyCode, setBuddyCode] = useState('');
  const [loading, setLoading] = useState(true);
  const [userGameIsCompleted, setUserGameIsCompleted] = useState(false);
  const [users, setUsers] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formErrors, setFormErrors] = useState({});

  // const loginType = localStorage.getItem('type');
  const modalContent = {
    title: t('How Buddy Tournament Works?'),
    message: "The standard Lorem Ipsum passage, used since the 1500s 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.' Section 1.10.32 of 'de Finibus Bonorum et Malorum', written by Cicero in 45 BC 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"
  }

  useEffect(() => {
    const userAgent = window.navigator.userAgent || "";
    const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    setIsIOS(isIOSDevice);
  }, []);


  useEffect(() => {
    const userType = getUserType();
    const userInfo = getUserInfo();

    if (userType === 'real_user' && userInfo && (userInfo.isTrialComplete === false && userInfo.trialCompleteAt === null)) {
      navigate(`/${BMICALCULATOR}`);
    } else if (userType) {
      navigate(`/${HOME}`);
    }
    setLoading(false);
  }, [navigate]);

  useEffect(() => {
    window.ReferedByAnotherUser = (buddyId, roomCode) => {
      const data = { buddyId, roomCode };
      localStorage.setItem('referralData', JSON.stringify(data));
    };

    return () => {
      window.ReferedByAnotherUser = null;
    };
  }, []);

  const handleGoBurn = async () => {
    const codeRef = document.getElementById("buddy_code");

    const errors = {};

    if (codeRef.value === "" || codeRef.value === null) {
      errors[codeRef.name] = t('Code is required.');
    }

    if (Object.keys(errors).length === 0) {
      try {
        const gameJoinData = {
          "fname": '',
          "lname": '',
          "code": buddyCode,
          "user": '',
        }
        const buddydata = await postDataWithToken(BUDDYGAMEJOIN, gameJoinData);
        if (buddydata.status === 200) {
          localStorage.setItem('joinGameId', buddydata.data._id);
          localStorage.setItem('joinPlayerId', buddydata.data.currentPlayId);
          localStorage.setItem('playerName', buddydata.data.newUser.name);
          
          setFormErrors({});
          navigate(`/${BUDDYTOURNAMENTJOIN}`);
        } else {
          errors[codeRef.name] = buddydata.message;
        }
      } catch (error) {}
    }
    setFormErrors(errors);
  };

  window.ReferedByAnotherUser = async function (buddyId, roomCode) {
    handleJoinPlayer(buddyId, roomCode);
  };

  const handleJoinPlayer = async (buddyId, roomCode) => {
    localStorage.setItem('referralData', JSON.stringify({ buddyId, roomCode }));
  };


  const guestLogin = () => {
    setSession();
    setUserType("guest_user");
    setLoading(true);
    navigate(`/${HOME}`);
  };

  const loginWithSocial = (socialType) => {
    setLoading(true); 
    try {
      window.location.href = `uniwebview://loginWithSocial?name=${socialType}`;
      LoggedInSocial(socialType);    
    } catch (error) {
      console.error("Error during social login:", error);
      setLoading(false);
    } 
  };
  
  const LoggedInSocial = (socialType) => {
    window.onSocialLoggedIn = async function (firstName, lastName, email) {
      let userData = {
        "fname": firstName,
        "lname": lastName,
        "email": email,
        "social": socialType
      };

      const response = await postData(LOGINWITHSOCIAL, userData);

      if (response.status === 200) {
        setSession(response.data);
        setUserType("real_user");
        setLoading(false); 
        if (!response.data.isTrialComplete && response.data.trialCompleteAt === null) {
          navigate(`/${BMICALCULATOR}`);
        } else {
          navigate(`/${HOME}`);
        }
      }
    };
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    setFormErrors({});
    
    const errors = {};
    if (!email.trim()) {
      errors.email = t('Email is required.');
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = t('Invalid email address.');
    }
    
    if (!password.trim()) {
      errors.password = t('Password is required.');
    } else if (password.length < 8) {
      errors.password = t('Password must be at least 8 characters.');
    }
    
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setLoading(false);
      return;
    }
    
    try {
      const response = await postData(LOGINUSER, { 
        email: email.trim(), 
        password: password.trim() 
      });
  
      if (response.status === 200) {
        setSession(response.data);
        setUserType("real_user");
        navigate((!response.data.isTrialComplete && response.data.trialCompleteAt === null) ? `/${BMICALCULATOR}` : `/${HOME}`);
        return;
      }
  
      if (response?.status === 422 && response?.message?.includes("OTP sent")) {
        navigate(`/${VERIFYOTP}`, {
          state: {
            userData: response.data,
            email: email.trim(),
            password: password.trim()
          }
        });
        return;
      }
  
      setFormErrors({
        general: response?.message || 
                 response?.data?.message || 
                 t('Login failed. Please try again.')
      });
      
    } catch (error) {
      console.error('Login error:', error);
      
      const errorMessage = error?.response?.data?.message ||error?.message ||t('An unexpected error occurred.');
      
      setFormErrors({ general: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='wrapper bg_paper d-flex flex-column h-100'>
      {loading ?
        <div className="loader">
          <Oval color="#daff00" secondaryColor="#ffffff" strokeWidth={3} strokeWidthSecondary={3} height={50} width={50} />
        </div>
        : ""}
      {showInfoModal || userGameIsCompleted ? (
        <BackButton label={t('Log in')} closeFunction={() => { setShowInfoModal(false); setUserGameIsCompleted(false); }} />
      ) : (
        null
      )}

      <div className='d-flex justify-content-center'>
        <StepProgressBar pendingStep={pendingStep} />
      </div>

      <div className='log_in_wrapper flex-fill d-flex flex-column'>
        <div className='logo_wrapper flex-fill d-flex justify-content-center align-items-center py-3'>
          <img src='../images/muvelogo.png' alt="MUVE" />
        </div>
        <div className='login-inner'>
          <div className='auth_section log_in_section bg-primary d-grid gap-3 p-3 rounded-4 text-center'>
            <h3 className='text-white fw-bold'>{t('Log in')}</h3>
            <form className='sign_up_form' autoComplete='off' onSubmit={handleLogin}>
              {formErrors.general && (
                <p className="error_message text-center my-2">{formErrors.general}</p>
              )}
              <div className='form_field position-relative mb-3'>
                <input type="email" name="email" id="email" className={`w-100 px-3 ${formErrors.email ? 'border-danger' : 'border'}`} placeholder={t('Email')} value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <p className='field_error'>{formErrors.email}</p>
              </div>
              <div className='form_field position-relative mb-3'>
                <input type="password" name="password" id="password" className={`w-100 px-3 ${formErrors.password ? 'border-danger' : 'border'}`} placeholder={t('Password')} value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <p className='field_error'>{formErrors.password}</p>
              </div>
              
              <button className='d-flex text-warning bg-transparent border-0 p-0 ms-auto' onClick={() => navigate(`/${FORGOTPASSWORD}`)}>
                {t('Forget Password?')}
              </button>

              <button  type='submit' className='text-white w-100 guest_button rounded-3 my-3' disabled={loading}>
                {t('Log In')}
              </button>
                <button className='text-warning bg-transparent border-0 p-0 text-center w-100' onClick={() => navigate(`/${REGISTER}`)}>{t('Create an account')}</button>
            </form>
            <div className='login_social_buttons d-flex gap-2'>
              <button onClick={() => loginWithSocial('Google')} className='bg-white text-primary border-0 rounded-3'><FcGoogle size={24} />{t('Login with Google')}</button>
              { isIOS  && <button className='bg-black text-white border-0 rounded-3' onClick={() => loginWithSocial('Apple')}><BiLogoApple className="me-1" size={24} />{t('Login with apple')}</button>}
            </div>
            <button className='text-white bg-info border-0 rounded-3 w-100 d-none' onClick={() => loginWithSocial('Facebook')}  disabled={loading} ><BiLogoFacebook size={24} />{t('Login with Facebook')}</button>
            <h6 className='position-relative mb-0 d-flex align-items-center text-light gap-3 d-none'>{t('or')}</h6>
            <button className='text-white w-100 guest_button border rounded-corners p-12 d-none' onClick={guestLogin}>{t('Guest Login')}</button>
          </div>
          <div className='login_tournament_sec gap-3 rounded-4 d-grid bg-primary p-3 position-relative mt-3 d-none'>
            <div className='d-flex gap-2 align-items-center'>
              <h3 className='text-white mb-0 fw-bold'>{t('Buddy Tournament')}</h3>
              <BiInfoCircle className='text-light buddy-tooltip' size={18} onClick={() => setShowInfoModal(true)} />
            </div>
            <div className='d-flex align-items-center position-relative'>
              <input type='text' id='buddy_code' name='buddy_code' placeholder={t('Paste your buddy ID')} className='w-100 px-3 me-2 bg-transparent' onChange={(e) => (setBuddyCode(e.target.value), setFormErrors({}))} />
              <p className='field_error'>{t(formErrors['buddy_code'])}</p>
              <button type='button' className='bg-info text-white d-flex align-items-center justify-content-center px-2 py-1 border-0' disabled={(buddyCode) ? false : true} onClick={() => handleGoBurn()}>
                {t('Go')}<BiRightArrowAlt size={25} color="white" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <InfoModal modalContent={modalContent} showInfoModal={showInfoModal}  />

      <div className={`modal ${userGameIsCompleted ? 'show' : ''}`} style={{ display: userGameIsCompleted ? 'block' : 'none' }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className='members_list px-4 py-3'>
            {
              users.map((user, index) => {
                return (
                  <div key={user._id} className={`item d-flex align-items-center gap-2 ${user.highest ? 'toper_user' : ''}`}>
                    <div className='member_profile rounded-circle position-relative'>
                      <h6 className='text-white mb-0'>{user.user !== null ? user.name.split(" ").slice(0, 2).map(word => word[0].toUpperCase()).join("") : 'P'}</h6>
                    </div>
                    <p className='mb-0 text-white user_name'>{user.user !== null ? user.name : 'Player_' + index}</p>
                    {/* <p className='mb-0 mx-auto user_status'>{(user.point !== 0) ? user.point : user.status}</p> */}
                    <p className='mb-0 ms-auto user_status'>{(user.userStatus) ? user.userStatus : ''}</p>
                    <div className={`d-flex align-items-center justify-content-center gap-1 game_status rounded-corners ${(user.status == 'Waiting') ? 'waiting' : ''}`}>
                      {(user.status !== 'Waiting') ? <span className='rounded-circle'>< FaCheck /></span> : null}
                      <p className='mb-0'>{(user.status === 'Waiting') ? 'Waiting...' : user.status}</p>
                    </div>
                    {(user.highest) ? <FaCrown className='position-absolute' /> : ''}
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>

      {(userGameIsCompleted || showInfoModal) && <div className="modal-backdrop show"></div>}

    </div>
  )
}

export default Login